import React from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete, AutocompleteRenderInputParams } from '@material-ui/lab';

import { ICustomAutocompleteSimple } from './interface';
import { IOptionData } from 'interfaces/utils';

const CustomAutocompleteSimple: React.FC<ICustomAutocompleteSimple> = ({
  list,
  onChange,
  autocompleteProps,
  textFieldProps,
}: ICustomAutocompleteSimple) => {
  const handleChange = (
    option: React.ChangeEvent<unknown>,
    newOption: IOptionData,
  ) => {
    onChange && onChange(newOption);
  };

  return (
    <Autocomplete
      options={list}
      getOptionLabel={(option: IOptionData) => option.label || ''}
      getOptionSelected={(option: IOptionData, value: IOptionData) =>
        option.value === value.value || value.value === ''
      }
      onChange={handleChange}
      disableClearable
      fullWidth
      renderInput={(params: AutocompleteRenderInputParams) => (
        <TextField margin="none" {...params} {...textFieldProps} />
      )}
      {...autocompleteProps}
    />
  );
};

export default CustomAutocompleteSimple;
